export enum GroupsTypes {
  ALL = 'all'
}
